import React from 'react';
import PropTypes from 'prop-types'
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button} from '@mui/material'
/**
 * Popup that lets user choose between two given options
 * @component 
 * @category Pop Ups
 */
function ChooseOptionPopUp(props) {
    return (
        <Dialog
        open={props.open}
        onClose={props.onClose}>
            <DialogTitle>
                {props.title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {props.body}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={(event) => {event.preventDefault(); props.onSelect(props.option1)}} autoFocus>{String(props.option1.string)}</Button>
                <Button onClick={(event) => {event.preventDefault(); props.onSelect(props.option2)}}>{String(props.option2.string)}</Button>
            </DialogActions>
        </Dialog>
    );
}

ChooseOptionPopUp.propTypes ={
    /**
     * whether or not the popup is open
     */
    open:PropTypes.bool.isRequired,
    /**
     * function to call upon closeing of the popup, returns clicking
     */
    onClose: PropTypes.func.isRequired,
    /**
     * function to call when selecting an option, passes either option1 or option2 depending on what is selected
     */
    onSelect: PropTypes.func.isRequired,
    /**
     * object representing the first option to choose from must have an option1.string field which will be displayed by the pop up
     */
    option1: PropTypes.object.isRequired,
    /**
     * object representing the first option to choose from must have an option2.string field which will be displayed by the pop up
     */
    option2: PropTypes.object.isRequired,
    /**
     * title of the popup
     */
    title: PropTypes.string,
    /**
     * body content of the popup
     */
    body: PropTypes.string
}

ChooseOptionPopUp.defaultProps = {
    title: "please chose one of the following"
}

export default ChooseOptionPopUp;